import React, { useEffect, useState } from "react";
import { List, Modal, Popconfirm, Skeleton } from "antd";
import { useLazyGetBuildingMapWorkOrdersQuery } from "../../store/services/api/work-order-api";
import {humanizeEnum} from "../../utils/humanizers";
import { WorkOrderType } from "../../store/data/entities/work-order";
import { WorkOrderStatus } from "../../store/data/entities/work-order";
import { Button } from "antd";
import {useNavigation} from "@react-navigation/native";



interface BuildingMapWorkOrdersModalProps {
  workOrderIds: string[];
  isOpen:boolean
  onClose: () => void;
}

export default function BuildingMapWorkOrdersModal({
  workOrderIds,
  isOpen,
  onClose
}: BuildingMapWorkOrdersModalProps) {
  const [getOpenWorkOrders, { data, isFetching }] =
    useLazyGetBuildingMapWorkOrdersQuery();

 const navigation = useNavigation<any>();
  useEffect(() => {

    getOpenWorkOrders({ workOrderIds });
  }, [isOpen, workOrderIds, getOpenWorkOrders]);


  const navigateToEdit = (id: string) => navigation.replace("workOrders", { 
    screen: "recordView", 
    params: { id}
  });

  return (
    <>


      <Modal
        centered
        width={1000}
        title="Work Orders"
        open={isOpen}
        onCancel={onClose}
        onOk={null}
      >
        <Skeleton loading={isFetching} active>
          <div
            style={{
              display: "flex",
              fontWeight: 600,
              borderBottom: "1px solid #f0f0f0",
              padding: "8px 16px",
            }}
          >
            <div style={{ flex: 2 }}>Work Order Reference</div>
            <div style={{ flex: 2 }}>Description</div>
            <div style={{ flex: 2 }}>Type</div>
            <div style={{ flex: 2 }}>Status</div>
            <div style={{ flex: 2 }}></div>
          </div>

          <List
            style={{ maxHeight: "50dvh", overflowY: "auto" }}
            dataSource={data?.list || []}
            renderItem={(item) => (
              <List.Item key={item.id} style={{ padding: "8px 16px" }}>
                <div style={{ flex: 2 }}>{item.reference}</div>
                <div style={{ flex: 2 }}>{item.description}</div>
                <div style={{ flex: 2 }}>{humanizeEnum(WorkOrderType[item.type])}</div>
                <div style={{ flex: 2 }}>{humanizeEnum(WorkOrderStatus[item.status])}</div>
                <div style={{ flex: 2, textAlign: "left" }}>
                  <Popconfirm
                    title="Are you sure you want to view this work order?"
                    onConfirm={() => navigateToEdit(item.id)}
                    >
                      <Button
                        type="link"
                      >
                        View Work Order
                      </Button>

                  </Popconfirm>
                  
                </div>
                
              </List.Item>
            )}
          />
        </Skeleton>
      </Modal>
    </>
  );
}
